import { render } from "./internal-history-overview.vue?vue&type=template&id=f98b026a&ts=true"
import script from "./internal-history-overview.ts?vue&type=script&lang=ts&external"
export * from "./internal-history-overview.ts?vue&type=script&lang=ts&external"

import "./../../generalizations/history-overview/history-overview.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__